import React from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import LoginForm from "../components/LoginForm";
import useTitle from "../components/Title";

const Login = () => {
  useTitle("- Login");

  return (
    <div className="">
      <Navbar />
      <div className="App-header mt-4">
        <div className="container-md">
          <LoginForm />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
